/**
 * Parses the `$id` segment of `/dashboard/issues/$id` to a positive integer,
 * or `null` for anything else (`abc`, `0`, `-1`, `1.5`, `1e3`, `0x10`, ` 5`,
 * empty, or beyond `Number.MAX_SAFE_INTEGER`).
 *
 * The digit-only test runs FIRST because bare `Number()` would happily turn
 * `'1e3'` into 1000 and `'0x10'` into 16, silently resolving a mangled link
 * to somebody's real issue; the `isSafeInteger && > 0` guard then rejects
 * zero and anything too large to be a real primary key. `null` (never a
 * throw) is deliberate: a route `params.parse` that throws lands on the
 * router's generic error boundary, whereas the past-issue screen turns
 * `null` into its own calm not-found state.
 */
export function parseIssueId(raw: string | undefined): number | null {
  if (raw === undefined || !/^\d+$/.test(raw)) return null;
  const n = Number(raw);
  return Number.isSafeInteger(n) && n > 0 ? n : null;
}
